import { useMemo } from 'react'

const channelProperties = {
  lipThickness: 2,
  channelThickness: 2,
  strokeWidth: 1,
  fillColour: '#757575',
  strokeColour: 'black',
}

type PropTypes = {
  height: number,
  width: number,
  xOffset?: number,
  yOffset?: number,
  anchorLength?: number,
  anchorThickness?: number,
  anchorHeadThickness?: number,
  anchorHeadDiameter?: number,
}

const SideOnChannel = ({
  height,
  width,
  xOffset = 0,
  yOffset = 0,
  anchorLength = 0,
  anchorThickness = 0,
  anchorHeadThickness = 0,
  anchorHeadDiameter = 0,
}: PropTypes) => {
  const lipLength = useMemo(() => height / 4, [height])

  const points = useMemo(() => {
    const points = [
      { x: xOffset + channelProperties.lipThickness, y: yOffset + lipLength },
      { x: xOffset, y: yOffset + lipLength },
      { x: xOffset, y: yOffset },
      { x: xOffset + width, y: yOffset },
      { x: xOffset + width, y: yOffset + height },
      { x: xOffset, y: yOffset + height },
      { x: xOffset, y: yOffset + height - lipLength },
      { x: xOffset + channelProperties.lipThickness, y: yOffset + height - lipLength },
      { x: xOffset + channelProperties.lipThickness, y: yOffset + height - channelProperties.channelThickness },
      { x: xOffset + width - channelProperties.channelThickness, y: yOffset + height - channelProperties.channelThickness },
      { x: xOffset + width - channelProperties.channelThickness, y: yOffset + channelProperties.channelThickness },
      { x: xOffset + channelProperties.lipThickness, y: yOffset + channelProperties.channelThickness },
    ]

    return points.map(point => `${point.x},${point.y}`).join(' ')
  }, [height, width, xOffset, yOffset, lipLength])

  return (
    <g>
      <polygon
        points={points}
        stroke={channelProperties.strokeColour}
        fill={channelProperties.fillColour}
        strokeWidth={channelProperties.strokeWidth}
      />
      <rect
        x={xOffset + width}
        y={yOffset + (height / 2) - (anchorThickness / 2)}
        width={anchorLength}
        height={anchorThickness}
        stroke={channelProperties.strokeColour}
        fill={channelProperties.fillColour}
        strokeWidth={channelProperties.strokeWidth}
      />
      <rect
        x={xOffset + width + anchorLength}
        y={yOffset + (height / 2) - (anchorHeadDiameter / 2)}
        width={anchorHeadThickness}
        height={anchorHeadDiameter}
        stroke={channelProperties.strokeColour}
        fill={channelProperties.fillColour}
        strokeWidth={channelProperties.strokeWidth}
      />
    </g>
  )
}

export default SideOnChannel
